export default __webpack_public_path__ + "static/zigzagexchange-f8245031c5b6c12bf0e6430854b8dde2.jpg";